export default [
    {
        type: "special",
        id: 1,
        title: "Personenbezogene Daten",
        items: [
            {
                id: 1,
                text: "In welcher Funktion sind sie tätig?",
                label: [
                    {
                        id: 1,
                        text: "Professor/in",
                    },
                    {
                        id: 2,
                        text: "Wissenschaftliches Personal",
                    },
                    {
                        id: 3,
                        text: "Sonstige",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 2,
                type: "small",
                text: "Wie viele Lehrveranstaltungen haben Sie dieses Semester durchgeführt?",
            },
            {
                id: 3,
                type: "small",
                text: "Wie viele Lehrveranstaltungen haben Sie dieses Semester digital durchgeführt?",
            },
            {
                id: 4,
                type: "medium",
                text: "An welcher Fakultät sind Sie tätig?",
            },
            {
                id: 5,
                type: "medium",
                text: "In welcher Fachrichtung sind Sie tätig?",
            },
        ],
    },
    {
        type: "uni",
        id: 3,
        title: "Allgemeine Erfahrung mit digitaler Lehre",
        items: [
            {
                id: 6,
                text: "Ich hatte in der Vergangenheit bereits digitale Lehre durchgeführt.",
            },
            {
                id: 7,
                text: "Ich hatte in der Vergangenheit meine Veranstaltungen durch digitale Elemente ergänzt.",
            },
            {
                id: 8,
                text: "Ich hatte bereits Weiterbildungen zum Thema digitale Lehre.",
            },
            {
                id: 9,
                text: "Meiner Meinung nach ist die Verfälschbarkeit bei digitalen Prüfungen ein großes Problem.",
            },
            {
                id: 10,
                text: "Ich bin der Meinung, dass digitale Prüfungen genauso gut geeignet sind wie das klassische Format.",
            },
            {
                id: 11,
                text: "Ich habe Angst davor Prüfungen digital abzuhalten, da hierdurch Klausurfragen besser veröffentlicht werden können und datenschutzrechtlich mehr Probleme auftreten.",
            },
            {
                id: 12,
                text: "Für die Dozierenden ist die digitale Lehre mit höherem Zeitaufwand (inkl. Vor und Nachbereitung) verbunden als die die klassische Lehre.",
            },
            {
                id: 13,
                text: "Für die Studierenden ist die digitale Lehre mit höherem Zeitaufwand (inkl. Vor und Nachbereitung) verbunden als die die klassische Lehre.",
            },
        ],
    },
    {
        type: "uni",
        id: 4,
        title: "Evaluation des Unterstützungsangebots",
        items: [
            {
                id: 14,
                text: "Ich wurde bezüglich rechtlicher Fragen gut informiert.",
            },
            {
                id: 15,
                text: "Ich wurde bezüglich organisatorischer / technischer Fragen gut informiert.",
            },
            {
                id: 16,
                text: "Ich wurde bezüglich didaktischer Fragen gut informiert.",
            },
            {
                id: 17,
                text: "Ich wusste immer an wen ich mich bei Fragen und Problemen bezüglich der digitalen Lehre wenden kann.",
            },
        ],
    },
    {
        type: "text",
        id: 5,
        items: [
            {
                id: 18,
                overrideTxtMsg: true,
                text: "Weitere Anmerkungen zum Unterstützungsangebot (Was war besonders gut? Was hat Ihnen gefehlt? Was hätte besser gemacht werden können?).",
            },
        ],
    },
    {
        type: "special",
        id: 6,
        title: "Evaluation von Hard- und Software",
        items: [
            {
                id: 19,
                text: "Musste zusätzliche Software angeschafft werden?",
                label: [
                    {
                        id: 1,
                        text: "Ja",
                    },
                    {
                        id: 2,
                        text: "Nein",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 7,
        items: [
            {
                id: 20,
                type: "medium",
                text: "Wenn ja, welche Software musste angeschafft werden?",
            },
        ],
    },
    {
        type: "special",
        id: 8,
        items: [
            {
                id: 21,
                text: "Musste zusätzliche Hardware angeschafft werden?",
                label: [
                    {
                        id: 1,
                        text: "Ja",
                    },
                    {
                        id: 2,
                        text: "Nein",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 9,
        items: [
            {
                id: 22,
                type: "medium",
                text: "Wenn ja, welche Hardware musste angeschafft werden?",
            },
        ],
    },
    {
        type: "uni",
        id: 10,
        items: [
            {
                id: 23,
                text: "Die zentrale IT Unterstützung war immer gegeben.",
            },
            {
                id: 24,
                text: "Fragen zu Hard- und Software Anschaffungen wurden immer zügig und kompetent beantwortet.",
            },
            {
                id: 25,
                text: "Die Hard- und Softwarebeschaffung war ausreichend schnell und einfach durchführbar.",
            },
            {
                id: 26,
                text: "Ich war technisch gut genug ausgestatt um digitale Lehre durchzuführen.",
            },
            {
                id: 27,
                text: "Die technische Ausstattung der Studierenden führe oft zu Problemen bei der digitalen Lehre.",
            },
        ],
    },
    {
        type: "special",
        id: 11,
        title: "Erfahrung mit dem Softwareangebot der UdS",
        items: [
            {
                id: 28,
                text: "Ich habe Moodle im Rahmen meiner Lehre eingesetzt.",
                label: [
                    {
                        id: 1,
                        text: "Ja",
                    },
                    {
                        id: 2,
                        text: "Nein",
                    },
                ],
            },
            {
                id: 29,
                text: "Ich habe MS Teams im Rahmen meiner Lehre eingesetzt.",
                label: [
                    {
                        id: 1,
                        text: "Ja",
                    },
                    {
                        id: 2,
                        text: "Nein",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 12,
        items: [
            {
                id: 30,
                type: "medium",
                text: "Wenn Sie noch weitere Tools eingesetzt haben, welche waren das?",
            },
        ],
    },
    {
        type: "uni",
        id: 13,
        items: [
            {
                id: 31,
                text: "Das mir zur Verfügung stehende Softwareangebot war leicht zu bedienen.",
            },
            {
                id: 32,
                text: "Das mir zur Verfügung stehende Softwareangebot war gut zur Digitalisierung der Lehre geeignet.",
            },
            {
                id: 33,
                text: "Das mir zur Verfügung stehende Softwareangebot erleichterte mir die Umstellung auf digitale Lehre.",
            },
        ],
    },
    {
        type: "uni",
        title:
            "Evaluation der Studierenden, der Kommunikation und Interaktion",
        id: 14,
        items: [
            {
                id: 34,
                text: "Ich habe sehr positive Rückmeldung zur Umstellung der Lehre bekommen.",
            },
            {
                id: 35,
                text: "Der Kontakt zu den Studierenden wurde durch die Umstellung der Lehre enger.",
            },
            {
                id: 36,
                text: "Die Studierenden haben genauso gut oder besser mitgearbeitet wie vor der Umstellung der Lehre.",
            },
            {
                id: 37,
                text: "Die Studierenden haben versucht gewisse Freiheiten im Rahmen der digitalen Lehre auszunutzen.",
            },
            {
                id: 38,
                text: "Sofern ich das beurteilen kann, finden Studierende die neue Form der Lehre gut.",
            },
        ],
    },
    {
        type: "text",
        title: "Anmerkungen",
        id: 15,
        items: [
            {
                id: 39,
                overrideTxtMsg: true,
                text: "Welche Probleme und Schwierigkeiten gibt es bei der Umsetzung digitaler Prüfungen?",
            },
            {
                id: 40,
                overrideTxtMsg: true,
                text: "Was darf bei digitalen Prüfungen unter keinen Umständen vorkommen?",
            },
            {
                id: 41,
                overrideTxtMsg: true,
                text: "Welche positiven Veränderungen (Weiterentwicklungen) haben Sie im Rahmen der Umstellung der Lehre festgestellt? Was sollte beibehalten werden?",
            },
            {
                id: 42,
                overrideTxtMsg: true,
                text: "Welche negativen Veränderungen (Beeinträchtigungen) haben Sie im Rahmen der Umstellung der Lehre festgestellt? Was sollte anders gelöst werden?",
            },
            {
                id: 43,
                overrideTxtMsg: true,
                text: "Haben wir einen Ihrer Meinung nach wichtigen Punkt übersehen? Teilen Sie uns hier bitte alles mit, was Ihnen noch wichtig erscheint.",
            },
        ],
    },
];